// Opens the Freshchat widget. Always go through this helper instead of calling
// window.fcWidget?.open() directly: the widget is lazy-loaded on first user
// interaction (see the bootstrap in index.html), so on the very first tap
// fcWidget may not exist yet and a direct call would silently do nothing.
// window.openFreshchat triggers the load and retries the open once the script
// has finished initialising.
export function openFreshchat() {
  if (typeof window.openFreshchat === 'function') {
    window.openFreshchat()
    return
  }
  // Fallback for any context where the index.html bootstrap didn't run.
  window.fcWidget?.open()
}
